import { CladdingProduct, Product, ProductType } from '../';

export function IsCladdingProduct(product: Product): product is CladdingProduct {
  return (product as CladdingProduct).productType === ProductType.CLADDING;
}
